module.exports = __webpack_public_path__ + "edd9986671672f80cd521c1e8de47bd7.svg";